<template>
  <div
    class="menu-container"
    :class="{ showing: showing }"
  >
    <redirect-external-links ref="redirector" />

    <ul class="menu__list">
      <router-link
        id="btnMenuHome"
        to="/dashboard"
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Home')"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-menu-home.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Home</span>
        </div>
      </router-link>
      <li
        v-if="!toggle.covax && toggle.xmlImport"
        id="btnMenuImportXml"
        class="menu__item"
        @click="setUploadModalVisible(true)"
        @mouseover="showMenu"
        @mouseout="hideMenu"
      >
        <div
          class="first-level"
          @click="submitAnalyticsEvent('Importar Arquivo XML')"
        >
          <svg-loader
            src="/static/images/icon-menu-xml.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Importar Arquivo XML</span>
        </div>
      </li>

      <li
        v-if="toggle.fileImport"
        id="btnMenuImportRoutine"
        class="menu__item"
        @click="importRoutine"
        @mouseover="showMenu"
        @mouseout="hideMenu"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-patient-routine.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Importar Rotina</span>
        </div>
      </li>

      <router-link
        v-if="toggle.patientManagement"
        id="btnPatientList"
        to="/patient"
        exact
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Cadastro Individual')"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/menu-icon-patient.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Cadastro Individual</span>
        </div>
      </router-link>

      <router-link
        v-if="toggle.manualServiceOrderRegistration"
        id="btnMenuNewOrder"
        to="/orders/new"
        exact
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Cadastrar Manualmente')"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-menu-cadastrar.svg"
            class="menu__item__icon narrow"
          />
          <span class="menu__item__text">Cadastrar Manualmente</span>
        </div>
      </router-link>

      <router-link
        v-if="!toggle.covax && toggle.interlabVoucher"
        id="btnVoucher"
        to="/voucher/new"
        exact
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Voucher Interlaboratorial')"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-voucher.svg"
            class="menu__item__icon smaller"
          />
          <span class="menu__item__text">Voucher Interlaboratorial</span>
        </div>
      </router-link>

      <router-link
        v-if="toggle.serviceOrderList"
        id="btnMenuOrders"
        :to="
          '/orders?filterBy=' +
          ORDER_STATE_PENDING_TRANSMISSION +
          '&filterBy=' +
          ORDER_STATE_FAIL
        "
        exact
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        :class="{ active: $route.meta.menuOrdersActive }"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Listagem de OS')"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-menu-listagem-os.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Listagem de OS</span>
        </div>
      </router-link>

      <router-link
        v-if="toggle.tagPrint"
        id="btnOsList"
        :to="toggle.patientView ? '/print-tag/samples' : '/print-tag/batches'"
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Impressão de Etiquetas')"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-barcode.svg"
            class="menu__item__icon bigger"
          />
          <span class="menu__item__text">Impressão de Etiquetas</span>
        </div>
      </router-link>

      <router-link
        v-if="!toggle.covax && (toggle.examResultsPDF || toggle.results)"
        id="btnPrintTag"
        to="/results"
        exact
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Resultados de Exames - XML')"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-menu-exames.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Resultados de Exames</span>
        </div>
        <div class="second-level second-level--three-items">
          <ul class="menu__submenu">
            <router-link
              v-if="toggle.results"
              id="btnMenuResultsLocal"
              :to="'/results'"
              tag="li"
              replace
              class="menu__submenu__item"
              active-class="submenu-active"
              @mouseover="showMenu"
              @mouseout="hideMenu"
              @click="submitAnalyticsEvent('Resultados de Exames - XML')"
            >
              XML
            </router-link>
            <router-link
              id="btnMenuResultsPDF"
              :to="'/results-pdf'"
              tag="li"
              replace
              class="menu__submenu__item"
              active-class="submenu-active"
              @mouseover="showMenu"
              @mouseout="hideMenu"
              @click="submitAnalyticsEvent('Resultados de Exames - PDF')"
            >
              Laudos em PDF
            </router-link>
            <router-link
              id="btnMenuResultsHistory"
              :to="'/results-history'"
              tag="li"
              replace
              class="menu__submenu__item"
              active-class="submenu-active"
              @mouseover="showMenu"
              @mouseout="hideMenu"
              @click="submitAnalyticsEvent('Histórico de Laudos')"
            >
              Laudo Histórico
            </router-link>
          </ul>
        </div>
      </router-link>

      <li
        v-if="toggle.covax && toggle.examResultsPDF"
        id="btnCovaxResult"
        class="menu__item"
        @mouseover="showMenu"
        @mouseout="hideMenu"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-menu-exames.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Resultados de exames</span>
        </div>
        <div class="second-level">
          <ul class="menu__submenu">
            <li
              id="btnMenuResultsExternal"
              class="menu__submenu__item"
              @click="openLaudasa()"
            >
              PDF
            </li>
          </ul>
        </div>
      </li>

      <li
        v-if="!toggle.covax && toggle.paternity"
        id="btnMenuPaternity"
        class="menu__item"
        @mouseover="showMenu"
        @mouseout="hideMenu"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-menu-paternidade.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Paternidade</span>
        </div>
        <div class="second-level">
          <ul class="menu__submenu">
            <li
              id="btnMenuResultsExternal"
              class="menu__submenu__item"
              @click="
                openExternalLink({
                  route: 'https://sislu.dasa.com.br/',
                  linkName: 'Paternidade - Já Possui Acesso',
                })
              "
            >
              Já Possui Acesso
            </li>
            <router-link
              id="btnMenuResultsLocal"
              to="/paternity"
              tag="li"
              replace
              class="menu__submenu__item"
              active-class="submenu-active"
              @mouseover="showMenu"
              @mouseout="hideMenu"
              @click="submitAnalyticsEvent('Paternidade - Não Possui Acesso')"
            >
              Não Possui Acesso
            </router-link>
          </ul>
        </div>
      </li>

      <li
        v-if="!toggle.covax && toggle.toxicology"
        id="btnMenuToxicological"
        class="menu__item"
        @click="openChromatoxLink()"
        @mouseover="showMenu"
        @mouseout="hideMenu"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-menu-toxicologico.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Toxicológico</span>
        </div>
      </li>

      <li
        v-if="!toggle.covax && toggle.shoppingCenter"
        id="btnMenuShoppingCart"
        class="menu__item"
        @click="openShoppingCentralLink()"
        @mouseover="showMenu"
        @mouseout="hideMenu"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-menu-cart.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Central de Compras</span>
        </div>
      </li>

      <router-link
        v-if="toggle.toggleManage && !toggle.covax"
        id="btnMenuAdmin"
        to="/admin"
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Gestão de Features')"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-menu-toggle.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Gestão de Features</span>
        </div>
      </router-link>

      <router-link
        v-if="
          toggle.notification_edit &&
          toggle.notification_edit !== undefined &&
          !toggle.covax
        "
        id="btnMenuNotification"
        to="/comunication-management"
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Central de Avisos')"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-menu-notification.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Central de Avisos</span>
        </div>
      </router-link>

      <router-link
        v-if="toggle.examDocument && !toggle.covax"
        id="btnMgmtFiles"
        to="/documents/new"
        exact
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Gestão de Documentos - Upload de Documentos')"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-file-new.svg"
            class="menu__item__icon"
          />
          <span class="menu__item__text">Gestão de Documentos</span>
        </div>
        <div class="second-level">
          <ul class="menu__submenu">
            <router-link
              id="btnMenuResultsLocal"
              :to="'/documents/new'"
              tag="li"
              replace
              class="menu__submenu__item"
              active-class="submenu-active"
              @mouseover="showMenu"
              @mouseout="hideMenu"
              @click="submitAnalyticsEvent('Gestão de Documentos - Upload de Documentos')"
            >
              Upload de Documentos
            </router-link>
            <router-link
              id="btnMenuResultsLocal"
              :to="'/documents/link'"
              tag="li"
              replace
              class="menu__submenu__item"
              active-class="submenu-active"
              @mouseover="showMenu"
              @mouseout="hideMenu"
              @click="submitAnalyticsEvent('Gestão de Documentos - Associar com Exames')"
            >
              Associar com Exames
            </router-link>
          </ul>
        </div>
      </router-link>

      <router-link
        v-if="toggle.reportGenerator"
        id="btnMenuReport"
        to="/gerar-relatorios"
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Gerar relatórios')"
      >
        <div class="first-level">
          <i class="md-icon menu__item__icon">
            <svg
              width="17"
              height="23"
              viewBox="0 0 17 23"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0)">
                <path
                  d="M0.369568 11.8462C0.369568 8.84125 0.369568 5.83726 0.369568 2.83427C0.369568 1.93378 1.08038 1.06597 1.95575 0.903062C2.12988 0.870268 2.30656 0.85344 2.48365 0.852783C5.33218 0.852783 8.18169 0.852783 11.0322 0.852783C11.5809 0.852783 12.0637 1.04083 12.4523 1.43149C13.6605 2.64723 14.8635 3.868 16.0614 5.0938C16.2463 5.28047 16.392 5.50317 16.4898 5.74849C16.5876 5.9938 16.6354 6.25665 16.6304 6.52122C16.6304 11.3017 16.6304 16.0821 16.6304 20.8622C16.6304 21.8135 15.881 22.6869 14.9501 22.8271C14.8483 22.8426 14.7456 22.8505 14.6428 22.8508C10.5451 22.8508 6.44746 22.8508 2.34982 22.8508C1.82654 22.8464 1.32585 22.6339 0.955502 22.2589C0.585152 21.8839 0.374747 21.3764 0.369568 20.8457C0.369568 17.8457 0.369568 14.8457 0.369568 11.8457V11.8462ZM2.40187 20.7908H14.5897V8.41924H14.4311C13.0313 8.41924 11.6313 8.4184 10.2312 8.41673C10.0995 8.41833 9.96854 8.3969 9.84405 8.35338C9.40884 8.18997 9.17339 7.82243 9.17339 7.3292C9.17339 5.91335 9.17339 4.49749 9.17339 3.08164V2.92729H2.40187V20.7908ZM11.2146 3.12589V6.34977H14.3974L11.2146 3.12589Z"
                  fill="#7f1a54"
                />
                <path
                  d="M8.49853 10.4811H12.4878C12.9726 10.4811 13.2462 10.7566 13.2467 11.2514C13.2487 12.3491 13.2487 13.4465 13.2467 14.5436C13.2467 15.9172 13.2442 17.2908 13.2467 18.6665C13.2467 18.9862 13.1257 19.2291 12.8343 19.3613C12.7319 19.4047 12.622 19.4268 12.5111 19.4262C9.83935 19.4299 7.16763 19.4307 4.4959 19.4287C4.03342 19.4287 3.75237 19.1416 3.75237 18.665C3.75039 17.3158 3.75039 15.9672 3.75237 14.619C3.75237 13.4965 3.75237 12.3736 3.75237 11.2503C3.75237 10.7546 4.02153 10.4816 4.50978 10.4816L8.49853 10.4811ZM5.11302 14.5979H7.81499V12.5521H5.11352L5.11302 14.5979ZM11.8895 12.5501H9.18406V14.5959H11.89L11.8895 12.5501ZM5.1155 15.9896V18.0375H7.81697V15.9896H5.1155ZM9.18505 15.9896V18.042H11.8855V15.9891L9.18505 15.9896Z"
                  fill="#7f1a54"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="16.2609"
                    height="22"
                    fill="white"
                    transform="translate(0.369568 0.852783)"
                  />
                </clipPath>
              </defs>
            </svg>
          </i>
          <span class="menu__item__text">Gerar relatórios</span>
        </div>
      </router-link>

      <router-link
        v-if="toggle.supplyManagement"
        id="btnMenuSupplies"
        to="/gestao-de-insumos"
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Solicitar Insumos')"
      >
        <div class="first-level">
          <i class="md-icon menu__item__icon narrow">
            <svg-loader
              src="/static/images/icon-gestao-de-insumos.svg"
              class="menu__item__icon smaller"
            />
          </i>
          <span class="menu__item__text">Solicitar Insumos</span>
        </div>
      </router-link>

      <router-link
        id="btnMenuSupplies"
        to="/documentos-obrigatorios"
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Documentos Obrigatórios')"
      >
        <div class="first-level">
          <i class="md-icon menu__item__icon narrow">
            <svg-loader
              src="/static/images/icon-doc-required.svg"
              class="menu__item__icon bigger"
            />
          </i>
          <span class="menu__item__text">Documentos Obrigatórios</span>
        </div>
      </router-link>

      <li
        v-if="toggle.genera"
        id="btnMenuGenera"
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
      >
        <div class="first-level">
          <svg-loader
            src="/static/images/icon-geneva.svg"
            class="menu__item__icon bigger"
          />
          <span class="menu__item__text">Genera</span>
        </div>
        <div class="second-level">
          <ul class="menu__submenu">
            <li
              id="btnMenuGeneraRegister"
              class="menu__submenu__item"
              active-class="submenu-active"
              @mouseover="showMenu"
              @mouseout="hideMenu"
              @click="
                openExternalLink({
                  route: 'https://exames.genera.com.br/cadastro-site',
                  linkName: 'Genera - Cadastrar paciente',
                })
              "
            >
              Cadastrar paciente
            </li>
            <li
              id="btnMenuGeneraResults"
              class="menu__submenu__item"
              active-class="submenu-active"
              @mouseover="showMenu"
              @mouseout="hideMenu"
              @click="
                openExternalLink({
                  route: 'https://exames.genera.com.br/',
                  linkName: 'Genera - Acessar resultado',
                })
              "
            >
              Acessar resultado
            </li>
          </ul>
        </div>
      </li>
      <router-link
        v-if="toggle.billetLink"
        id="btnMenuBillings"
        to="/faturamento"
        tag="li"
        replace
        class="menu__item"
        active-class="active"
        @mouseover="showMenu"
        @mouseout="hideMenu"
        @click="submitAnalyticsEvent('Financeiro')"
      >
        <div class="first-level">
          <i class="md-icon menu__item__icon narrow">
            <svg-loader
              src="/static/images/money.svg"
              class="menu__item__icon smaller"
            />
          </i>
          <span class="menu__item__text">Financeiro</span>
        </div>
      </router-link>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formartDateFromArray } from '@/utils/date-utils'
import { ORDER_STATE_FAIL, ORDER_STATE_PENDING_TRANSMISSION } from '@/enums'
import RedirectExternalLinks from '@/components/common/RedirectExternalLinks'

export default {
  name: 'MainMenu',
  components: {
    'redirect-external-links': RedirectExternalLinks,
  },
  data: () => {
    return {
      ORDER_STATE_FAIL: ORDER_STATE_FAIL,
      ORDER_STATE_PENDING_TRANSMISSION: ORDER_STATE_PENDING_TRANSMISSION,
      showing: false,
    }
  },
  computed: {
    ...mapGetters(['toggle']),
  },
  computed: {
    ...mapGetters(['profile', 'toggle', 'getTodayDate', 'preference', 'isTutorialRead']),
    today: function () {
      return formartDateFromArray(this.getTodayDate)
    },
  },
  created() {
    if (this.profile === null) {
      this.getUserProfile()
    }
  },
  mounted() {
    this.clearAlertDataForLaboratory()
    this.clearAllMessageData()
    this.updateToday()
    this.getAlertsForLaboratory()
    this.getMessagesForLaboratory()
  },
  methods: {
    ...mapActions([
      'getAlertsForLaboratory',
      'getMessagesForLaboratory',
      'clearAlertDataForLaboratory',
      'clearAllMessageData',
      'updateToday',
      'getUserProfile',
      'setUploadModalVisible',
      'setUploadFileModalVisible',
    ]),
    falseLink(e) {
      e.preventDefault()
    },
    showMenu() {
      this.showing = true
    },
    hideMenu() {
      this.showing = false
    },
    openExternalLink({ route, linkName }) {
      window.open(route)
      this.submitAnalyticsEvent(linkName)
    },
    openChromatoxLink() {
      this.$refs.redirector.getTokenAndRedirect('CHROMATOX')
      this.submitAnalyticsEvent('Toxicológico')
    },
    openShoppingCentralLink() {
      this.$refs.redirector.getTokenAndRedirect('SHOPPING_CENTER')
      this.submitAnalyticsEvent('Central de Compras')
    },
    openLaudasa() {
      this.$refs.redirector.getTokenAndRedirect('LAUDASA')
      this.submitAnalyticsEvent('Resultados de Exames - PDF')
    },
    submitAnalyticsEvent(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Links do Menu',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
      })
    },
    importRoutine() {
      if (this.profile.laboratoryTypeOutputResult === 'DIAVERUM') {
        this.$router.push('/patient-routine?filterBy=P')
      } else {
        this.setUploadFileModalVisible(true)
      }

      this.submitAnalyticsEvent(
        'Importar Arquivo - ' + this.profile.laboratoryTypeOutputResult
      )
    },
  },
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';

.menu-container {
  background-color: #fff;
  width: $menuWidth;
  flex-grow: 0;
  margin-top: 143px;
  position: fixed;
  height: 100%;
  z-index: 11;
  border-right: 1px solid #dbdbdb;
  transition: width 0.3s;
  transition-delay: 0.15s;

  &.tall-menu {
    margin-top: 58px;

    &:hover {
      width: 231px;
      transition: width 0.3s;
      overflow-y: auto;
      scrollbar-face-color: #7f1a54;
      scrollbar-track-color: #c2c2c2;
      padding-bottom: 58px;

      &::-webkit-scrollbar {
        width: 5px;
      }

      &::-webkit-scrollbar-track {
        background: #c2c2c2;
        border-radius: 60px;
      }

      &::-webkit-scrollbar-thumb {
        background: #7f1a54;
        border-radius: 60px;

        &:hover {
          background: #551338;
        }
      }

      .menu__item__text {
        opacity: 1;
        transition: opacity 0.3s 0.1s, margin-left 0.1s;
        margin-left: 5px;
      }

      .menu__new-warning {
        right: 13px;
      }
    }
  }

  .menu {
    &__item {
      display: flex;
      flex-direction: column;
      cursor: pointer;
      position: relative;
      outline: 0;
      margin: 0;

      &:not(.md-button) {
        color: #4c4f59;
      }

      &:hover {
        z-index: 10;

        &:not(.md-button) {
          color: #4c4f59;
          text-decoration: none;
        }

        .menu__item__text {
          color: #4c4f59;
        }

        .menu__item__icon {
          border-left: 3px solid #7f1a54;
        }

        .second-level {
          height: 65px;
          transition: height 0.2s;

          &--three-items {
            height: 94px;
          }
        }
      }

      &.active {
        z-index: 10;

        .menu__item__text {
          color: #4c4f59;
        }

        .menu__item__icon {
          border-left: 3px solid #7f1a54;
        }
      }

      .first-level {
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .second-level {
        width: 100%;
        height: 0px;
        overflow: hidden;
        transition: height 0.2s;
      }

      &__icon {
        padding: 12px 0;
        border-left: 3px solid #fff;
        height: 50px;
        width: 50px;
        display: flex;
        justify-content: center;
        margin: 0;

        svg {
          width: 22px;
        }

        &.narrow svg {
          width: 18px;
        }

        &.bigger svg {
          width: 30px;
        }
      }

      .smaller svg {
        width: 21px;
        height: 21px;
      }

      &__text {
        font-size: 12px;
        font-weight: 500;
        line-height: 1.17;
        letter-spacing: 0.5px;
        text-align: center;
        color: #949497;
        opacity: 0;
        transition: opacity 0.3s, margin-left 0.1s 0.3s;
        margin-left: -300px;
      }
    }
    &__submenu {
      margin: 2px 0 24px 52px;

      &__item {
        font-size: 12px;
        color: #949497;
        text-align: left;
        margin: 0 0 13px 4px;
        font-weight: 500;
        display: flex;
        flex-wrap: nowrap;
        white-space: nowrap;

        &::before {
          content: '■';
          color: #7f1a54;
          display: inline-block;
          width: 17px;
          margin-right: 10px;
          font-size: 8px;
        }

        &:hover {
          color: #4c4f59;
        }

        &:last-child {
          margin-bottom: 0;
        }

        a,
        a:hover,
        a:visited {
          color: inherit;
          text-decoration: none;
        }
      }
    }

    &__new-warning {
      display: flex;
      width: 35px;
      height: 15px;
      border-radius: 8px;
      background: #ff1a75;
      color: #fff;
      font-size: 11px;
      font-style: normal;
      font-weight: bold;
      justify-content: center;
      align-items: center;
      position: absolute;
      right: -13px;
      top: 7px;
      transition: all 0.2s linear;
    }
  }
  &.showing {
    width: 231px;
    transition: width 0.3s;
    overflow-y: auto;
    scrollbar-face-color: #7f1a54;
    scrollbar-track-color: #c2c2c2;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #c2c2c2;
      border-radius: 60px;
    }

    &::-webkit-scrollbar-thumb {
      background: #7f1a54;
      border-radius: 60px;

      &:hover {
        background: #551338;
      }
    }

    .menu__list {
      padding-bottom: 58px;
    }

    .menu__item__text {
      opacity: 1;
      transition: opacity 0.3s 0.1s, margin-left 0.1s;
      margin-left: 5px;
    }

    .menu__new-warning {
      right: 13px;

      &.long {
        right: 0;
        top: 0;
      }
    }
  }

  .menu__list {
    padding-bottom: 58px;
  }
}
</style>
